<template>
  <component
    :is="selectedPage ? PTCLink : 'span'"
    :to="selectedPage ? linkUrl : undefined"
    :target="selectedPage && openInNewTab ? '_blank' : undefined"
    :class="{
      'internal-link inline-block': true,
    }"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import PTCLink from '~/components/Atmos/PTCLink/PTCLink.vue';
import type { InternalLink } from '~/sanity/types';
import { useRefsStore } from '~/composables/refsStore';

const { getResolvedInternalLinkRef } = useRefsStore();
const props = defineProps<InternalLink>();
const resolvedInternalLink = await getResolvedInternalLinkRef(props.selectedPage?.reference?._ref);
const linkUrl = computed(() => {
  if (!resolvedInternalLink.value) {
    return '#';
  }
  return `${resolvedInternalLink.value.currentPathname}${props.query ? '?' + props.query : ''}`;
});
</script>

<style lang="scss" scoped></style>
